import React from 'react';
import { ChevronDown, ChevronUp, AlertTriangle } from 'lucide-react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Input from '../../../components/ui/Input';

const HazardCategory = ({ expanded, onToggle, formData, setFormData }) => {
  const hazardCategories = [
    'Slips, Trips, and Falls',
    'Struck By/Against',
    'Caught In/Between',
    'Electrical Hazards',
    'Chemical Exposure',
    'Fire/Explosion',
    'Ergonomic Issues',
    'Machine Guarding',
    'Height/Elevation',
    'Confined Space',
    'Temperature Extremes',
    'Noise Exposure'
  ];

  const toggleHazard = (hazard) => {
    setFormData(prev => ({
      ...prev,
      hazardCategories: prev?.hazardCategories?.includes(hazard)
        ? prev?.hazardCategories?.filter(h => h !== hazard)
        : [...prev?.hazardCategories, hazard]
    }));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50"
        onClick={onToggle}
      >
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 text-orange-600" />
          <h2 className="text-lg font-semibold text-gray-900">Hazard Categories</h2>
        </div>
        {expanded ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
      </div>
      {expanded && (
        <div className="p-4 pt-0 border-t border-gray-200">
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              {hazardCategories?.map((hazard) => (
                <label 
                  key={hazard}
                  className="flex items-center gap-2 p-2 rounded hover:bg-gray-50 cursor-pointer"
                >
                  <Checkbox
                    checked={formData?.hazardCategories?.includes(hazard)}
                    onChange={() => toggleHazard(hazard)}
                  />
                  <span className="text-sm text-gray-700">{hazard}</span>
                </label>
              ))}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Other Hazard (specify)
              </label>
              <Input
                value={formData?.customHazard}
                onChange={(e) => setFormData(prev => ({ ...prev, customHazard: e?.target?.value }))}
                placeholder="Describe any other hazards not listed above"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HazardCategory;